////////////////////////////////////////////////////////////////////
// This file contains configs that add analytics integrations     //
////////////////////////////////////////////////////////////////////

// Note: These come from the analytics asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeAnalyticsConfig func)

// Optional
// Note that Google Analytics might need advanced opt-out option / cookie consent
// depending on jurisdiction (e.g. EU countries), since it relies on cookies.
export const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// Optional: the ID used to LOAD gtag.js when it differs from the GA4
// measurement ID. When Google has combined the GA4 stream into a "Google tag"
// shared with Google Ads (AW-…) or a GT-… tag, only that combined ID is
// loadable — requesting gtag.js with the bare G- ID returns 404 and nothing is
// sent. Set this to the ID GA4 shows under "View tag instructions" (e.g.
// AW-1234567890); the G- ID above is still configured as the GA4 destination.
export const googleTagId = process.env.REACT_APP_GOOGLE_TAG_ID;

// Optional
// If you add this Plausible integration, you should first create an account in plausible.io
// This adds data-domains for Plausible script through environment variable: REACT_APP_PLAUSIBLE_DOMAINS
// https://plausible.io/docs/plausible-script#can-i-send-stats-to-multiple-dashboards-at-the-same-time
// You can add multiple domains separated by comma
// E.g. REACT_APP_PLAUSIBLE_DOMAINS=example1.com,example2.com
export const plausibleDomains = process.env.REACT_APP_PLAUSIBLE_DOMAINS;
